import React from 'react';
import { WithLoading } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';
import { passwordField } from 'constants/fields';
import UTForm from 'app/components/UTForm';

import styles from './styles.module.scss';

const fields = [
  { ...passwordField, key: 'password', title: message('Signin:newPassword') },
  { ...passwordField, key: 'password_confirmation', title: message('Signin:newPasswordConfirmation') }
];

const ChangePassword = () => <UTForm fields={fields} fieldClasses={{ container: styles.input }} />;

export default WithLoading(props => props.loading)(ChangePassword);
